import { DataCache, DataCacheCollection, QueryResultsRelationship } from 'lib/DataCache';
import { PCCache } from 'data/PCCache';
import { InviteUsersResponse } from 'data/models/InviteUsersResponse';

export class InviteUsersCache extends DataCache {
    // The InviteUsersController doesn't take any parameters. Use a dummy key to force this to be a singleton.
    InviteUsersResponses = new DataCacheCollection(InviteUsersResponse, InviteUsersResponse.update, r => 1, r => 1);

    constructor(data : PCCache) {
        super();
        new QueryResultsRelationship(this.InviteUsersResponses, data.Roles,         r => r.AssignableRoles);
        new QueryResultsRelationship(this.InviteUsersResponses, data.Organizations, r => r.AvailableOrganizations);
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/inviteusers/cache.ts